import {Util} from 'yougile-util'
import {
  DeadlineStickerValue,
  getRepeatTemplateDeadlineShift,
  Hub,
  repeatTemplatesContainerId
} from 'yougile-model'
import {StickerHub} from '@extensions/sticker/views-web/a-sticker-view'
import {Task} from '@extensions/task'

const updateStickerDates = (val: DeadlineStickerValue, shift: number): void => {
  if (val.current.deadline) {
    val.current.deadline += shift
  }
  if (val.current.startDate) {
    val.current.startDate += shift
  }
}

export const toVisualDeadline = (
  task: StickerHub,
  dl: DeadlineStickerValue
): DeadlineStickerValue => {
  if (!dl) {
    return dl
  }

  let val = dl
  if (task.location === repeatTemplatesContainerId && val.current) {
    val = Util.clone(dl)
    Task.getByIdOrNull(task.id, task => {
      const shift = getRepeatTemplateDeadlineShift(task)
      updateStickerDates(val, shift)
    })
  }
  return val
}

export const toServerDeadline = (
  task: Hub,
  dl: DeadlineStickerValue
): DeadlineStickerValue => {
  if (!dl) {
    return dl
  }
  const val = Util.clone(dl)
  if (task.location === repeatTemplatesContainerId && val.current) {
    const shift = getRepeatTemplateDeadlineShift(task)
    updateStickerDates(val, -shift)
  }
  return val
}
